import { render, staticRenderFns } from "./MultiConnectTable.vue?vue&type=template&id=6480fc53"
import script from "./MultiConnectTable.vue?vue&type=script&lang=js"
export * from "./MultiConnectTable.vue?vue&type=script&lang=js"
import style0 from "./MultiConnectTable.vue?vue&type=style&index=0&id=6480fc53&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports